import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchProductsB2B } from "../services";

export const fetchProductsB2BData = createAsyncThunk(
  "productsB2B/fetchProductsB2BData",
  async (countryId, { rejectWithValue }) => {
    try {
      const data = await fetchProductsB2B(countryId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const productB2BSlice = createSlice({
  name: "productsB2B",
  initialState: {
    data: [],
    loading: true,
    error: null,
    product: null
  },
  reducers: {
    // Puedes agregar más acciones sincronas si es necesario
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductsB2BData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsB2BData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProductsB2BData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default productB2BSlice.reducer;
